import * as _ from 'underscore';
import { L10n } from '../L10n/L10n';
import { IGroupInfo } from '../models/IGroupInfo';
import { Module } from '../Module';
import { Groups } from '../resources/Groups';
import { IResult } from '../ServerApi/types/IResponse';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { RenameGroupActionNotification } from './GroupsActionNotification';

export interface IUpdateGroupNameDialogScope extends ng.IScope {
  description: string;
  input: {
    text: string;
    maxLength?: number;
  };
}

export class UpdateGroupNameAction {

  public static $inject = ['$translate',
                           'ConfirmActionDialog',
                           'Groups',
                           'RenameGroupActionNotification'];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private ConfirmActionDialog: ConfirmActionDialog,
    private Groups: Groups,
    private renameGroupActionNotification: RenameGroupActionNotification) { }

  // update group name on the groups list page (confirmation dialog with text input for name entry).
  public showUpdateGroupNameDialog(group: IGroupInfo, parentScope: ng.IScope): ng.IPromise<IResult> {

    const dialogScope = <IUpdateGroupNameDialogScope> parentScope.$new();
    dialogScope.description = this.$translate.instant('updateGroupNameDesc', {
      GROUP_NAME: L10n.elideIfLong(group.name)
    });
    dialogScope.input = {
      text: group.name,
      maxLength: 255
    };

    const dialogInstance = this.ConfirmActionDialog.open({
      title: this.$translate.instant('updateGroupNameTitle'),
      bodyTemplateUrl: 'confirmActionDialogInput.html',
      scope: dialogScope,
      position: { reserveHeight: 250 },
      confirmDisabled: () => _.isEmpty(dialogScope.input.text),
      actionName: this.$translate.instant('updateGroupNameTitle'),
      action: (dialogInstance: IConfirmActionDialogInstance) => {
        return this.Groups.updateGroupName(group.id, dialogScope.input.text).then((result: IResult) => {
          this.renameGroupActionNotification.notify(
            (errorMsg: string) => {
              dialogInstance.showErrorMessage(errorMsg);
            },
            result,
            dialogScope.input.text,
            group.name);
          return result;
        });
      }
    });
    dialogInstance.result.finally(() => dialogScope.$destroy());
    return dialogInstance.result;
  }
}

Module.instance().service('UpdateGroupNameAction', UpdateGroupNameAction);
